import React, { useState } from "react";
import style from "./navbar.module.css";
import cv from "../../Files/CV.pdf";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickBurguer = (e) => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={style.container}>
      <div className={isOpen ? style.infoOpen : style.info}>
        <a href="/#home">Home</a>

        <a href="/#skills">Skill</a>
        <a href="/#projects">Projects</a>
        <a href={cv} download="CV">
          CV
        </a>
        <a href="/#Contact">Contact</a>
      </div>
      <div
        onClick={handleClickBurguer}
        className={isOpen ? style.burguerOpen : style.burguer}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}
